import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    headerRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
        marginBottom: 16,
    },
    lede: {
        color: '#5a5a6a',
        marginTop: 4,
        maxWidth: 520,
    },
    search: {
        maxWidth: 260,
        width: '100%',
        backgroundColor: '#ffffff',
    },
    pillRow: {
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap',
        marginBottom: 20,
    },
    chip: {
        padding: '6px 14px',
        borderRadius: 8,
        border: `1px solid ${theme.palette.grey[100]}`,
        background: 'transparent',
        color: theme.palette.grey[600],
        fontSize: 13,
        fontFamily: 'inherit',
        cursor: 'pointer',
        transition: 'all .12s',
        '&:hover': {
            borderColor: '#9a9aaa',
        },
    },
    chipActive: {
        background: theme.palette.grey[800],
        borderColor: theme.palette.grey[800],
        color: '#ffffff',
        '&:hover': {
            borderColor: theme.palette.grey[800],
        },
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
        gap: 14,
        alignItems: 'stretch',
    },
    card: {
        background: '#ffffff',
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: 12,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        transition: 'all .12s',
        '&:hover': {
            borderColor: '#9a9aaa',
            boxShadow: '0px 3px 11px 0px #E8EAFC',
        },
    },
    cardTop: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 8,
    },
    logo: {
        width: 40,
        height: 40,
        flexShrink: 0,
        borderRadius: 8,
        border: '1px solid rgba(0, 0, 0, 0.08)',
        background: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        padding: 4,
    },
    logoImg: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    initials: {
        fontSize: 13,
        fontWeight: 700,
        color: '#1a1a2f',
    },
    cardCat: {
        fontSize: 10,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: '#9a9aaa',
        fontWeight: 500,
    },
    cardName: {
        marginBottom: 4,
    },
    cardDesc: {
        color: '#6b6b7a',
        lineHeight: 1.45,
    },
    cardCta: {
        marginTop: 'auto',
        alignSelf: 'flex-start',
    },
    empty: {
        textAlign: 'center',
        color: '#9a9aaa',
        padding: 40,
        border: '1px dashed #C9CDEC',
        borderRadius: 8,
    },
    loaderBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
    },
    modal: {
        padding: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },
    modalHeader: {
        display: 'flex',
        gap: 12,
        alignItems: 'center',
    },
    modalBody: {
        color: '#4a4a52',
        lineHeight: 1.6,
    },
    modalSubtitle: {
        color: '#6b6b7a',
        marginTop: -8,
    },
    features: {
        listStyle: 'none',
        padding: 0,
        margin: '4px 0 0',
    },
    feature: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        marginBottom: 8,
    },
    checkIcon: {
        color: theme.palette.success.main,
        fontSize: 18,
        marginTop: 2,
        flexShrink: 0,
    },
}));
